import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["onClick", "invisible"];
import '../../css-tokens';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Box from '../Box';
import styles from './index.module.css';

const Backdrop = /*#__PURE__*/function () {
  const Backdrop = /*#__PURE__*/forwardRef(function (_ref, ref) {
    var onClick = _ref.onClick,
        invisible = _ref.invisible,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);

    return /*#__PURE__*/React.createElement(Box, _extends({
      "aria-hidden": "true",
      ref: ref,
      className: cx(styles.root, !invisible && styles.background),
      onClick: onClick
    }, rest));
  });
  Backdrop.propTypes = {
    invisible: PropTypes.bool,
    onClick: PropTypes.func
  };
  Backdrop.defaultProps = {
    zIndex: 600
  };
  return Backdrop;
}();

export default Backdrop;